import {ResponseBase} from "../../data";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Stat} from "../../data/mqttStatistics";
import {ChartData} from "tmwx-design-common";

export interface MqttStatisticsState {
    response: ResponseBase | null;
    isLoading: boolean;
    error: ResponseBase | null;
    incomingMsgs: ChartData[];
    subscriptions: ChartData[];
    connectedCount: number;
}

const initialState: MqttStatisticsState = {
    response: null,
    isLoading: false,
    error: null,
    incomingMsgs: [],
    subscriptions: [],
    connectedCount: 0
};

const mqttStatisticsSlice = createSlice({
    name: "mqttStatisticsSlice",
    initialState: initialState,
    reducers: {
        setResponse(state, action: PayloadAction<ResponseBase | null>) {
            state.response = action.payload;
            state.isLoading = false;
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
        setIncomingMsgs(state, action: PayloadAction<ChartData[]>) {
            state.incomingMsgs = action.payload;
            state.isLoading = false;
        },
        setSubscriptions(state, action: PayloadAction<ChartData[]>) {
            state.subscriptions = action.payload;
            state.isLoading = false;
        },
        setConnectedCount(state, action: PayloadAction<number>) {
            state.connectedCount = action.payload;
            state.isLoading = false;
        },
        setError(state, action: PayloadAction<ResponseBase | null>) {
            state.isLoading = false;
            state.error = action.payload;
        }
    }
});

export const mqttStatisticsActions = mqttStatisticsSlice.actions;
export default mqttStatisticsSlice;